export default __webpack_public_path__ + "static/media/team-photo-2019.fd773668.jpg";